module.exports = __webpack_public_path__ + "static/cs2-510a2e3db2cfdbf08c436e605f594971.jpg";